import {
  getBookDemoUrl,
  // @ts-expect-error - getCustomerPlan is not typed yet
  getCustomerPlan,
  isPlanFromBusinessCategory,
  isUserAllowedToBookDemo,
} from 'src/data/subscription';
// @ts-expect-error - useCurrentCustomer is not typed yet
import { useCurrentCustomer } from 'src/store/customer';
// @ts-expect-error - useCurrentUser is not typed yet
import { useCurrentUser } from 'src/store/user';

interface Result {
  bookDemoUrl: string;
  allowedToBookDemo: boolean;
}

export const useBookDemoInfo = (): Result => {
  const currentUser = useCurrentUser();
  const userAllowedToBookDemo = isUserAllowedToBookDemo(currentUser);

  const currentCustomer = useCurrentCustomer();
  const plan = getCustomerPlan(currentCustomer);
  const isBusinessPlan = isPlanFromBusinessCategory(plan);

  const bookDemoUrl = getBookDemoUrl();
  const allowedToBookDemo = Boolean(bookDemoUrl) && (isBusinessPlan || userAllowedToBookDemo);

  return { bookDemoUrl, allowedToBookDemo };
};
